import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibIconButtonComponent } from './icon-button.component';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [
    LibIconButtonComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule
  ],
  exports: [
    LibIconButtonComponent
  ]
})
export class LibIconButtonModule { }
